import { Observable } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';

export function add_event_documents(componentDataSourceService: ComponentDataSourceService) {
    return {
      name: 'Event Documents',
      description: 'Lists all documents associated with the event and their visibility settings',
      execute: () => {
        return new Observable(subscriber => {
          subscriber.next([
            {
              filename: 'Øvelsesbeskrivelse.pdf',
              visibility: 'Instruktør'
            },
            {
              filename: 'Deltagerliste.xlsx',
              visibility: 'Instruktør'
            },
            {
              filename: 'Sikkerhedsinstruks.pdf',
              visibility: 'Deltager'
            },
            {
              filename: 'Materialeplan.pdf',
              visibility: 'Instruktør'
            },
            {
              filename: 'Øvelsesplan.pdf',
              visibility: 'Deltager'
            }
          ]);
          subscriber.complete();
        });
      },
      settings: {
        columns: [
          { key: 'filename', header: 'Filnavn', type: 'text' },
          { 
            key: 'visibility', 
            header: 'Synlighed', 
            type: 'select',
            options: [
              { value: 'Deltager', label: 'Deltager' },
              { value: 'Instruktør', label: 'Instruktør' }
            ]
          }
        ],
        pageable: true,
        sortable: true,
        rowHover: true,
        defaultSortColumn: 'filename',
        defaultSortDirection: 'asc'
      }
    }
}
